import { Button, Col, Form, Modal, Row, Select } from "antd";
import { PlatVariacio } from "../../../model/menudesign/PlatVariacio";
import { useEffect, useState } from "react";
import { GetPlats } from "../../../dao/menudesign/GetPlats";
import { GetVariacio } from "../../../dao/menudesign/GetVariacio";
import Variacio from "../../../model/menudesign/Variacio";
import { PostVariantsPlat } from "../../../dao/menudesign/PostVariantsPlat";
import { BiCheck, BiX } from "react-icons/bi";
import Colors from "../../../styles/Colors";

interface IngredientModalProps {
    element: PlatVariacio;
    visible: boolean;
    page: string;
    editar?: boolean;
    onClose: () => void;
}
const PlatVariacioModal: React.FC<IngredientModalProps> = ({element, visible, page, editar, onClose}) => {
    const [form] = Form.useForm();
    const [plats, setPlats] = useState<{ value: number; label: string; }[]>([]);
    const [variants, setVariants] = useState<{ value: number; label: string; }[]>([]);
    
    async function checkListas(){
        const dades = await GetPlats(page) || [];
        const variants = await GetVariacio(page);
        const platList = dades.map((element) => ({
            value: element.id,
            label: element.nom,
        }));
        const varList = variants.map((element: Variacio) => ({
            value: element.id,
            label: element.nom,
        }))
        setPlats(platList);
        setVariants(varList);
    }
    async function handleSubmit() {
        const id_plat = await form.getFieldValue('id_plat');
        const id_variacio = await form.getFieldValue('id_variacio');
        const id_alternativa = await form.getFieldValue('id_alternativa');
        await PostVariantsPlat(id_plat,id_variacio,id_alternativa,page);
        await onClose();
    };
    async function handleCancel() {
        await onClose();
    };
    useEffect(() => {
        checkListas();
    }, []);
    if(!editar){
        return (
            <Modal
            title="Mostrar Variant de Plat"
                open={visible}
                onCancel={handleCancel}
                footer={[
                    <>
                        <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                                onClick={handleSubmit}><BiCheck/></Button>
                        {" "}
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </>
                ]}
                width={500}
            >
                <Form form={form} initialValues={element}>
                    <br/>
                    <Row gutter={[16, 16]}>
                        <Col span={42}>
                            <Form.Item label="ID Plat" name="id_plat"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={plats}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item label="ID Variant" name="id_variacio"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={variants}
                                    disabled
                                />
                            </Form.Item>
                            <Form.Item label="ID Plat alternatiu" name="id_alternativa"
                            rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Select
                                    showSearch
                                    optionFilterProp="label"
                                    options={plats}
                                    disabled
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        )
    }
    return (
        <Modal
        title="Crear/Editar Variant de Plat"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={500}
        >
            <Form form={form} initialValues={element}>
                <br/>
                <Row gutter={[16, 16]}>
                    <Col span={42}>
                        <Form.Item label="ID Plat" name="id_plat">
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={plats}
                            />
                        </Form.Item>
                        <Form.Item label="ID Variant" name="id_variacio">
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={variants}
                            />
                        </Form.Item>
                        <Form.Item label="ID Plat alternatiu" name="id_alternativa">
                            <Select
                                showSearch
                                optionFilterProp="label"
                                options={plats}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
}
export default PlatVariacioModal;